import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TABLET, DESKTOP } from "common/constants/breakpoints";

export interface AppState {
  upTabletScreen: boolean;
  upDesktopScreen: boolean;
  firstTimeEntering: boolean;
}

const initialState: AppState = {
  upTabletScreen: window.innerWidth >= TABLET,
  upDesktopScreen: window.innerWidth > DESKTOP,
  firstTimeEntering: true,
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setUpDesktopScreen(state: AppState, action: PayloadAction<boolean>) {
      state.upDesktopScreen = action.payload;
    },
    setUpTabletScreen(state: AppState, action: PayloadAction<boolean>) {
      state.upTabletScreen = action.payload;
    },
    setFirstTimeEntering(state: AppState, action: PayloadAction<boolean>) {
      state.firstTimeEntering = action.payload;
    },
  },
});

export const { setUpDesktopScreen, setUpTabletScreen, setFirstTimeEntering } =
  appSlice.actions;

export default appSlice.reducer;
